import React from 'react';
import PropTypes from 'prop-types';
import { getConfig } from '@edx/frontend-platform';
import { PluginSlot } from '@openedx/frontend-plugin-framework';
import { Button } from '@openedx/paragon';

const CourseDatesCalendarExportButton = ({ courseId }) => {
  const href = `${getConfig().LMS_BASE_URL}/calendar_export/${courseId}.ics`;

  return (
    <Button
      as="a"
      href={href}
      download
      variant="outline-primary"
      size="sm"
      className="mb-2 mb-sm-0"
    >
      Export to Calendar
    </Button>
  );
};

CourseDatesCalendarExportButton.propTypes = {
  courseId: PropTypes.string.isRequired,
};

const CourseDatesActionsSlot = ({ courseId }) => (
  <PluginSlot
    id="org.openedx.frontend.learning.course_dates_actions.v1"
    idAliases={['course_dates_actions_slot']}
    slotOptions={{
      mergeProps: true,
    }}
    pluginProps={{
      courseId,
    }}
  >
    <CourseDatesCalendarExportButton courseId={courseId} />
  </PluginSlot>
);

CourseDatesActionsSlot.propTypes = {
  courseId: PropTypes.string.isRequired,
};

export default CourseDatesActionsSlot;
